import { Api } from 'utils';

class ConfigService {
	
	static get = async (params?: any) => Api.createResponse('client/config',params);
	static save = async (params?: any) => Api.createResponse('client/config/save',params);
	static saveCountry = async (params?: any) => Api.createResponse('client/config/save-country',params);

}

export default ConfigService;